import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/home/runner/work/dex-frontend/dex-frontend/apps/web/src/app/(networks)/(evm)/(trade)/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DerivedstateSimpleSwapProvider"] */ "/home/runner/work/dex-frontend/dex-frontend/apps/web/src/app/(networks)/(evm)/(trade)/swap/_ui/derivedstate-simple-swap-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EdgeProvider"] */ "/home/runner/work/dex-frontend/dex-frontend/apps/web/src/providers/edge-config-provider.tsx");
